var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUruguay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.95433 0 3.05176e-05 8.9543 3.05176e-05 20C3.05176e-05 31.0457 8.95433 40 20 40Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 14.7825H39.3111C38.8096 12.922 38.0474 11.1688 37.0646 9.56506H20.0001V14.7825Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.55034 35.6521H32.4498C34.275 34.1984 35.8403 32.4326 37.0645 30.4347H2.93558C4.15987 32.4325 5.72519 34.1984 7.55034 35.6521V35.6521Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 -0.00012207V4.34769H32.4498C29.0334 1.62675 24.707 -0.00012207 20 -0.00012207V-0.00012207Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 14.7825H39.3112C38.8097 12.922 38.0475 11.1688 37.0647 9.56506H20.0002V14.7825Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05176e-05 20C3.05176e-05 21.8052 0.240656 23.5538 0.689015 25.2174H39.3111C39.7594 23.5538 40 21.8052 40 20H3.05176e-05Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3914 11.7047L14.9487 12.8537L16.2494 15.2193L13.5971 14.712L13.261 17.3913L11.4136 15.4207L9.56612 17.3913L9.2301 14.712L6.57776 15.2192L7.87838 12.8536L5.43588 11.7047L7.87846 10.5559L6.57776 8.19026L9.23002 8.69761L9.56619 6.01831L11.4136 7.98894L13.261 6.01831L13.5971 8.69761L16.2495 8.19026L14.9488 10.556L17.3914 11.7047Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUruguay);
export default __webpack_public_path__ + "static/media/uruguay.2684692614faac00d8864affd990e4d4.svg";
export { ForwardRef as ReactComponent };